<div class="catalogs-list-container">
  <div class="filters">
    <div class="search-filter-group">
      <!-- Filter Button -->
      <div class="filter-button-group">
        <button class="action-btn secondary-btn" [class.activeFilter]="getFiltersCount() > 0" (click)="openFilter()">
          <div class="icon">
            <app-svg-icon svgIcon="filter-cc"></app-svg-icon>
          </div>
          <span>
            {{ "common.filter" | translate }}
          </span>
          <div class="clear-icon-container">
            <img
              class="clear-icon"
              *ngIf="getFiltersCount() > 0"
              (click)="clearFilter(); $event.stopPropagation()"
              src="assets/icones/clear-icon.svg"
              alt=""
            />
            <div class="clear-tooltip" *ngIf="getFiltersCount() > 0">
              {{ "common.clear_filters" | translate }}
            </div>
          </div>
        </button>
      </div>

      <!-- Search Box -->
      <div class="standard-input has-icon search-box">
        <div class="input-container">
          <input
            type="text"
            placeholder="{{ 'agent.catalogue.search' | translate }}"
            [formControl]="searchInput"
            (input)="search($event)"
          />
          <div class="btn-icon" style="cursor: default;">
            <img src="assets/icones/search_icon.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="catalogs-list-content">
    <table class="catalogs-table">
      <thead>
        <tr class="row header" style="padding-top: 10px; border: unset; height: unset">
          <th>
            <mat-checkbox [checked]="isAllCatalogsSelected()" [indeterminate]="isPartialSelectedAll()" (change)="toggleAllCatalogs($event.checked)">
            </mat-checkbox>
            {{ "agent.catalogue.image" | translate }}
          </th>
          <th>
            {{ "agent.catalogue.name" | translate }}
          </th>
          <th>
            {{ "agent.catalogue.total_skus" | translate }}
          </th>
          <th style="display: flex; align-items: center">
            {{ "agent.catalogue.creation_date" | translate }}
            <div class="sort-actions">
              <span class="arrow-up" [class.active]="activeSortMode == 'asc'" (click)="sortByCreationDate('asc')"></span>
              <span class="arrow-down" [class.active]="activeSortMode == 'desc'" (click)="sortByCreationDate('desc')"></span>
            </div>
          </th>
        </tr>
        <tr class="row header" style="padding-bottom: 10px; height: unset">
          <th></th>
          <th></th>
          <th>
            <span style="font-weight: 400" class="secondary-text">{{ "agent.catalogue.total_quantity" | translate }}</span>
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <cdk-virtual-scroll-viewport itemSize="50" class="catalogs-viewport" [class.no-disclaimer]="noDisclaimer">
          <ng-container *cdkVirtualFor="let catalogue of filteredCatalogs">
            <tr class="row">
              <td>
                <mat-checkbox
                  [checked]="selectedCatalogs.includes(catalogue.id!)"
                  (change)="toggleCatalogue(catalogue.id!, $event.checked)"
                ></mat-checkbox>
                <img
                  class="thumbmail-image"
                  [class]="!catalogue.image ? 'no-image' : ''"
                  [src]="failedImages.has(catalogue.image!) ? 'assets/icones/default-image-product.svg' : getImage(catalogue.image!)"
                  alt=""
                  (error)="onImageError(catalogue.image!)"
                />
              </td>
              <td>
                <div style="display: flex; flex-direction: column">
                  <span class="truncate" style="width: 250px">{{ catalogue.name }}</span>
                  <span class="secondary-text">{{ catalogue.id }}</span>
                </div>
              </td>
              <td>
                <div style="display: flex; flex-direction: column">
                  <span class="truncate" style="width: 250px">{{ catalogue.nbr_products }}</span>
                  <span class="secondary-text">{{ catalogue.total_quantity }}</span>
                </div>
              </td>
              <td>
                <span style="padding-left: 5px">{{ catalogue.create_date | date : DATE_FORMAT }}</span>
              </td>
            </tr>
          </ng-container>
          <ng-container *ngIf="!filteredCatalogs.length">
            <div style="height: 200px; display: flex; align-items: center; justify-content: center" class="secondary-text">
              {{ "agent.catalogue.no_data" | translate }}
            </div>
          </ng-container>
        </cdk-virtual-scroll-viewport>
      </tbody>
    </table>
  </div>
</div>
